module.exports = __webpack_public_path__ + "img/clarkhowellhall-v-474x632.679f9145.jpg";